/**
 * Mirrors `@fs/zion-adobe-target`'s `shouldSkipAdobeTarget` (Safari + prerender bots): the provider
 * skips Adobe Target for these clients — under Safari's ITP it can't persist an assignment — so they
 * never receive an assigned experience.
 *
 * We have to replicate the check here because `useAdobeTarget` doesn't surface "was skipped", and an
 * A/B test that waits on an offer needs it to avoid waiting forever for an offer that will never
 * arrive. These clients fall straight through to the control arm.
 */
export default function isAdobeTargetSkipped() {
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : ''

  return userAgent.includes('prerender') || /^((?!chrome|android).)*safari/i.test(userAgent)
}
